import profileImg from "./assets/profile-img.svg";

export const API_BASE_URL = "https://getessy.io/api/api";
export const base_url = "https://getessy.io/";

export const profileImgSrc = `${profileImg}`;
